export const isEmptyArr = (arr: any[] | undefined) => {
  if (arr && arr.length > 0) return false
  return true
}
